export default "__VITE_ASSET__Dzm5vnOq__"